<script>
import RegionalCommissionMixin from '@/mixin/common/RegionalCommissionMixin'
import { ErrorTip } from '@/utils/class/ErrorTip'
import { cache, cacheName } from '@/utils/cacheManager'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'

export default {
  mixins: [RegionalCommissionMixin],
  data() {
    const hqViewAllList = this.$checkPermission(['role_hqViewAllListAtBusiness']) || this.$checkPermission(['role_hqViewAllDetailAtBusines'])
    const hqViewAllDetail = this.$checkPermission(['role_hqViewAllDetailAtBusines'])
    let hierarchyViewList = false
    let hierarchyViewDetail = false
    if (this.isZy) {
      hierarchyViewList = !hqViewAllList && this.$checkPermission(['role_ViewHierarchicalListAtBusiness']) || this.$checkPermission(['role_ViewHierarchicalDetailAtBusiness'])
      hierarchyViewDetail = !hqViewAllList && this.$checkPermission(['role_ViewHierarchicalDetailAtBusiness'])
    } else {
      hierarchyViewList = this.$checkPermission(['role_ViewHierarchicalListAtBusiness']) || this.$checkPermission(['role_ViewHierarchicalDetailAtBusiness'])
      hierarchyViewDetail = this.$checkPermission(['role_ViewHierarchicalDetailAtBusiness'])
    }
    return {
      hqViewAllList,
      hqViewAllDetail,
      hierarchyViewList,
      hierarchyViewDetail,
      isZy: false,
      childOfficeIds: []
    }
  },
  computed: {
    hierarchyDisabledViewDetail() {
      if (this.hierarchyViewList && !this.hierarchyViewDetail) {
        return !this.hierarchyValidSingleSelect
      }
      return false
    },
    hierarchyValidSingleSelect() {
      const job = this.selectedJob || this.selectedRow
      if (this.hierarchyViewList && job) {
        return this.matchOwnerBranch(job)
      }
      return true
    },
    zyHierarchyValidSingleSelect() {
      const job = this.selectedJob || this.selectedRow
      if (this.hierarchyViewList && job) {
        if (this.childOfficeIds.includes(job.opOffice) || this.childOfficeIds.includes(job.salesOffice)) {
          return true
        }
        return this.matchOwnerBranch(job)
      }
      return true
    },
    hierarchyValidMultipleSelect() {
      if (this.hierarchyViewList) {
        const rows = this.selectedRows
        for (const row of rows) {
          if (!this.matchOwnerBranch(row)) {
            return false
          }
        }
      }
      return true
    }
  },
  watch: {
    '$store.getters.currentOfficeId': {
      immediate: true,
      async handler() {
        await cache.load(cacheName.CONFIG)
        this.isZy = String(cache.config.get('ToExoSystem')) === 'zy'
        this.childOfficeIds = JobUtils.getChildOfficeIds(this.$store.getters.currentOfficeUuid)
      }
    }
  },
  methods: {
    // 匹配所属分公司
    matchOwnerBranch(row) {
      if (row.opOffice !== this.$store.getters.currentOfficeId && row.salesOffice !== this.$store.getters.currentOfficeId && !this.matchCooperateBranch(row.cooperatebranch, this.$store.getters.currentOffice)) {
        return false
      }
      return true
    },
    // 匹配协作分公司
    matchCooperateBranch(cooperateBranch, office) {
      if (cooperateBranch && office) {
        const list = cooperateBranch.split(' | ')
        if (list && list.length > 0) {
          for (const officeName of list) {
            if (officeName === office.chineseName) {
              return true
            }
          }
        }
      }
      return false
    },
    // 校验所属分公司（多选）
    /**
     * 检查所选行是否属于当前分支。
     * 如果任何一行不属于当前分支，则抛出一个错误提示。
     * @param {Array} rows - 需要检查的行数组。
     * @throws {ErrorTip} 如果存在不属于当前分支的行，则抛出错误提示。
     */
    checkOwnerBranch(rows) {
      for (const row of rows) {
        if (!this.matchOwnerBranch(row)) {
          throw new ErrorTip(this.$t('queryJob.SelectNotBelongToCurBranch'))
        }
      }
    },
    // 校验层级多选
    checkHierarchyMulitple() {
      if (this.hierarchyViewList) {
        const rows = this.selectedRows
        for (const row of rows) {
          if (!this.matchOwnerBranch(row)) {
            this.$message.warning(this.$t('queryJob.SelectNotBelongToCurBranch'))
            return false
          }
        }
      }
      return true
    }
  }
}
</script>
